"use client";

import * as X from "@/ui";
import { ErrorPage } from "@/stage/Error";


export default function Error(props: {
  error: Error;
  reset(): void;
}) {
  const tr = X.useTranslator();

  X.useEffect([props.error], () => {
    console.error(props.error);
  });

  const title = tr({
    en: "Error - Zapptax",
    fr: "Erreur - Zapptax",
  });

  return (
    <>
      <title>{title}</title>
      <ErrorPage type="runtimeError" />
    </>
  );
}
